var exports = {
  "k": "container__MgyYr4",
};

module.exports = exports;
